'use client';

import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

const PHONE_NUMBER = '5521973440236';

export const useWhatsAppLink = () => {
  const searchParams = useSearchParams();

  const getWhatsAppLink = useCallback((adName?: string) => {
    // Check for UTM parameters
    const utmContent = searchParams?.get('utm_content');
    const utmCampaign = searchParams?.get('utm_campaign');
    
    // Priority: explicit adName > utm_content > utm_campaign
    const finalAdName = adName || utmContent || utmCampaign;

    let message = '';
    
    if (finalAdName) {
      message = `Olá, vim do site pelo anúncio ${finalAdName}. Gostaria de mais informações.`;
    } else {
      message = 'Olá, vim do site e gostaria de mais informações.';
    }

    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${PHONE_NUMBER}?text=${encodedMessage}`;
  }, [searchParams]);

  return getWhatsAppLink;
};
